import type { PropertyDetails } from '@urbanx/agx.campaigns.client';
import { LegalDescriptionModel, PropertyAttributesModel } from '@urbanx/agx-ui-components';
import { useAppSelector } from '../hooks/useAppSelector';

const useFormPropertyDetailsSelector = (): Partial<PropertyDetails> => {
  const legalDescription =
    useAppSelector<LegalDescriptionModel | undefined>(
      (state) => state.form.formValues.LegalDescription
    ) ?? {};

  const propertyAttributes =
    useAppSelector<PropertyAttributesModel | undefined>(
      (state) => state.form.formValues.PropertyAttributes
    ) ?? {};

  const propertyDetailsFromFormConfig =
    useAppSelector<PropertyDetails | undefined>((state) => state.form.propertyDetails) ?? {};

  return {
    ...propertyDetailsFromFormConfig,
    ...legalDescription,
    ...propertyAttributes,
  };
};

export default useFormPropertyDetailsSelector;
